<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.7263 3.7263C4.02808 3.42453 4.51733 3.42453 4.8191 3.7263L12 10.9072L19.1809 3.7263C19.4827 3.42453 19.9719 3.42453 20.2737 3.7263C20.5754 4.02808 20.5754 4.51733 20.2737 4.8191L13.0928 12L20.2737 19.1809C20.5754 19.4827 20.5754 19.9719 20.2737 20.2737C19.9719 20.5754 19.4827 20.5754 19.1809 20.2737L12 13.0928L4.8191 20.2737C4.51733 20.5754 4.02808 20.5754 3.7263 20.2737C3.42453 19.9719 3.42453 19.4827 3.7263 19.1809L10.9072 12L3.7263 4.8191C3.42453 4.51733 3.42453 4.02808 3.7263 3.7263Z"
            fill="currentColor"
        />

        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.72633 3.72633C4.0281 3.42456 4.51736 3.42456 4.81913 3.72633L12 10.9072L19.1809 3.72633C19.4826 3.42456 19.9719 3.42456 20.2737 3.72633C20.5754 4.0281 20.5754 4.51736 20.2737 4.81913L13.0928 12L20.2737 19.1809C20.5754 19.4826 20.5754 19.9719 20.2737 20.2737C19.9719 20.5754 19.4826 20.5754 19.1809 20.2737L12 13.0928L4.81913 20.2737C4.51736 20.5754 4.0281 20.5754 3.72633 20.2737C3.42456 19.9719 3.42456 19.4826 3.72633 19.1809L10.9072 12L3.72633 4.81913C3.42456 4.51736 3.42456 4.0281 3.72633 3.72633Z"
            fill="currentColor"
        />

        <!-- FILL -->
        <path
            v-else
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.77662 3.77662C4.14545 3.40779 4.74344 3.40779 5.11227 3.77662L12 10.6644L18.8877 3.77662C19.2566 3.40779 19.8546 3.40779 20.2234 3.77662C20.5922 4.14545 20.5922 4.74344 20.2234 5.11227L13.3356 12L20.2234 18.8877C20.5922 19.2566 20.5922 19.8546 20.2234 20.2234C19.8546 20.5922 19.2566 20.5922 18.8877 20.2234L12 13.3356L5.11227 20.2234C4.74344 20.5922 4.14545 20.5922 3.77662 20.2234C3.40779 19.8546 3.40779 19.2566 3.77662 18.8877L10.6644 12L3.77662 5.11227C3.40779 4.74344 3.40779 4.14545 3.77662 3.77662Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
    export default {
        name: 'close-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
